import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ListingsService } from '../../../services/listings/listings';

@Component({
  selector: 'app-lightbox-map',
  styleUrl: './lightbox-map.css',
  templateUrl: './lightbox-map.html',
})
export class LightboxMap {
  private readonly _domSanitizer = inject(DomSanitizer);
  private readonly _listingsService = inject(ListingsService);

  public readonly listingId = input.required<string>();

  protected readonly mapUrl = computed(() =>
    this._domSanitizer.bypassSecurityTrustResourceUrl(
      `https://app.v3.thevillages.com/map-image-generator/?id=${this.listingId()}&fill=%23dc2626&outline=%23dc2626&type=polygon`,
    ),
  );
}
